var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "third-upload cnt1200" },
    [
      _c("page-header", { attrs: { title: "", paths: ["上传答题卡图片"] } }, [
        _c("p", { staticClass: "download", on: { click: _vm.downloadExe } }, [
          _vm._v(" 下载客户端 "),
          _c("img", {
            attrs: {
              src: require("@/v3/modules/card_use/assets/images/download-icon.png"),
              width: "16px",
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "upload-body" }, [
        _c(
          "div",
          { staticClass: "upload-basic" },
          [
            _c("span", { staticClass: "span-label" }, [_vm._v("年级：")]),
            _c(
              "el-select",
              {
                attrs: {
                  size: "mini",
                  placeholder: "选择年级",
                  disabled: _vm.selectDisabled,
                },
                on: {
                  change: function ($event) {
                    return _vm.loadSubjects()
                  },
                },
                model: {
                  value: _vm.upload.grade,
                  callback: function ($$v) {
                    _vm.$set(_vm.upload, "grade", $$v)
                  },
                  expression: "upload.grade",
                },
              },
              _vm._l(_vm.gradeList, function (grade, index) {
                return _c("el-option", {
                  key: "grade" + index,
                  attrs: { label: grade.gradeName, value: grade.gradeNum },
                })
              }),
              1
            ),
            _c(
              "span",
              {
                staticClass: "span-label",
                staticStyle: { "margin-left": "40px" },
              },
              [_vm._v("学科：")]
            ),
            _c(
              "el-select",
              {
                attrs: {
                  size: "mini",
                  placeholder: "选择科目",
                  disabled: _vm.selectDisabled,
                },
                model: {
                  value: _vm.upload.subjectCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.upload, "subjectCode", $$v)
                  },
                  expression: "upload.subjectCode",
                },
              },
              _vm._l(_vm.subjectList, function (subject, index) {
                return _c("el-option", {
                  key: "subject" + index,
                  attrs: {
                    label: subject.subjectName,
                    value: subject.subjectId,
                  },
                })
              }),
              1
            ),
            _c(
              "span",
              {
                staticClass: "span-label",
                staticStyle: { "margin-left": "40px" },
              },
              [_vm._v("阅卷方式：")]
            ),
            _c(
              "el-select",
              {
                attrs: {
                  size: "mini",
                  placeholder: "选择阅卷方式",
                  disabled: _vm.selectDisabled,
                },
                model: {
                  value: _vm.upload.isHen,
                  callback: function ($$v) {
                    _vm.$set(_vm.upload, "isHen", $$v)
                  },
                  expression: "upload.isHen",
                },
              },
              _vm._l(_vm.hens, function (hen, index) {
                return _c("el-option", {
                  key: "hen" + index,
                  attrs: { label: hen.name, value: hen.value },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "upload-pic" },
          [
            _c("span", { staticClass: "span-label" }, [_vm._v("上传图片：")]),
            _c("client-scan", {
              attrs: {
                type: "scan-card-template",
                exam: _vm.examDemo,
                "paper-num": 1,
              },
              on: { change: _vm.uploadedAction },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "upload-images" },
          [
            _vm.upload.ossUrl
              ? _c(
                  "div",
                  { staticClass: "upload-image" },
                  [
                    _c("el-image", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        src: _vm.upload.ossUrl,
                        "preview-src-list": [_vm.upload.ossUrl],
                        fit: "scale-down",
                      },
                    }),
                    _c("span", {
                      staticClass: "el-icon-circle-close",
                      on: {
                        click: function ($event) {
                          _vm.upload.ossUrl = ""
                        },
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "el-button",
                  { staticClass: "upload-image", attrs: { disabled: "" } },
                  [
                    _c("p", { staticClass: "add" }, [
                      _c("img", {
                        attrs: {
                          alt: "添加图片",
                          src: require("../../assets/images/add_img.png"),
                        },
                      }),
                    ]),
                  ]
                ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "upload-footer" },
          [
            _c("p", [_vm._v("支持 jpg、png格式，小于5M")]),
            _c(
              "el-button",
              {
                staticClass: "ok-btn",
                attrs: { type: "primary", size: "mini" },
                on: {
                  click: function ($event) {
                    _vm.createCard(function (data) {
                      _vm.showCut(data)
                    })
                  },
                },
              },
              [_vm._v("制作模板")]
            ),
            !_vm.upload.examId
              ? _c(
                  "el-button",
                  {
                    staticClass: "ok-btn",
                    attrs: { size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.createCard()
                      },
                    },
                  },
                  [_vm._v("确定")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }